import OnboardingSignup from './components/OnboardingSignup.js';
import connect from './connect';
import './assets/OnboardingSignup.css';

export default connect(OnboardingSignup);



// WEBPACK FOOTER //
// ./src/routes/OnboardingSignup/index.js